import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "Em quanto tempo eu começo a ver resultado?",
        a: "A maioria das pessoas relata mudança real entre o Dia 7 e o Dia 14, quando o cérebro começa a montar frases sem traduzir. O plano completo entrega resultado em 30 dias, com 20 a 40 minutos por dia.",
    },
    {
        q: "Eu sou iniciante. Esse método é para mim?",
        a: "O e-book é otimizado para quem já tem base — entende razoavelmente, mas trava na hora de falar. Se você está zerado, o método ainda funciona, mas o ritmo dos 30 dias será mais desafiador.",
    },
    {
        q: "Como recebo o material?",
        a: "Logo após a confirmação do pagamento, o link de acesso vai direto para o seu e-mail. Você baixa em PDF e pode ler no celular, tablet ou computador, quando quiser.",
    },
    {
        q: "Tenho garantia de verdade?",
        a: "Sim. Você tem 7 dias para testar o método. Se não gostar, envia um e-mail e devolvemos 100% do valor — sem perguntas, sem burocracia.",
    },
    {
        q: "Preciso de assinatura de algum app?",
        a: "Não. O método usa ferramentas gratuitas (Anki, Language Reactor, podcasts grátis). Você não precisa pagar mais nada para aplicar.",
    },
    {
        q: "Por que tão barato?",
        a: "Porque o objetivo é destravar o máximo de brasileiros possível. R$ 47 é o preço de um almoço — e o retorno (carreira, viagens, autoestima) é incomparável.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="section-faq"
            className="bg-cream py-24 lg:py-32"
        >
            <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="text-center max-w-2xl mx-auto reveal">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="hairline w-10" />
                        <span className="label-eyebrow">Perguntas frequentes</span>
                        <span className="hairline w-10" />
                    </div>
                    <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
                        Antes de você pensar em desistir.
                    </h2>
                </div>

                <Accordion
                    type="single"
                    collapsible
                    className="mt-12"
                    data-testid="faq-accordion"
                >
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-b border-cream"
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="font-serif text-emerald-brand text-lg sm:text-xl text-left hover:no-underline py-6">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-emerald-light/85 text-base leading-relaxed pb-6 pr-2">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
